<template>
    <ul
        class="list-group text-uppercase slide sub move-in"
        v-if="items.length"
    >
        <test-navigation-list-item
            v-for="(item, itemIndex) in items"
            :key="itemIndex + 0"
            :item="item"
            :level="level + 1"
            :showLevel="showLevel"
            :index="index + '-' + itemIndex"
            @next-level="emitNextLevel"
        ></test-navigation-list-item>
    </ul>
</template>

<script>
export default {
  data () {
    return {
      scrollLevel: 0
    }
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    level: {
      default: 0,
      type: Number,
      required: false
    },
    showLevel: {
      default: null,
      type: String | Number,
      required: true
    },
    index: {
      type: String | Number,
      required: true
    }
  },
  methods: {
    emitNextLevel: function (nextLevel) {
      this.$emit('next-level', nextLevel)
    }
  }
}
</script>

<style scoped>
    .sub {
        visibility: visible;
    }
</style>



// WEBPACK FOOTER //
// src/components/test/NavigationList.vue